import { MasterService } from './../services/master.service';
import { Component, OnInit, Input, Output, EventEmitter, Injectable   } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { PaginationInstance } from 'ngx-pagination';

declare function iOS_data(input: string):void;
declare function andriod_data(input: string):void;

@Component({
  selector: 'app-scanned-implants',
  templateUrl: './scanned-implants.component.html',
  styleUrls: ['./scanned-implants.component.scss']
})

export class ScannedImplantsComponent implements OnInit {


  public scannedImplants: any;
  public filter: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  stockPageId = 'stockPageId';
  pageEvent: PageEvent;
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  placeHolder: any = 'Search By Product Code';

  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;
  public viewPermission = false;
  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };
  
  bool = false;
  public mobile;
  public mobile_device;

  // tslint:disable-next-line:max-line-length
  constructor(public masterService: MasterService) { }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['scanned_implants.view'] == 1 ) {
        this.viewPermission = true;
      }
    }

    this.filter = {
      token: localStorage.getItem('token')      
    };

    this.getScannedImplantsData();

    //Scanning by mobile 
    var userAgent = navigator.userAgent || navigator.vendor;   

    if (/android/i.test(userAgent)) {
        this.mobile = true;
        this.mobile_device = 'android';
    }
    if (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ) {
        this.mobile = true;
        this.mobile_device = 'iOS';
    }
    console.log('Mobile & Device:'+this.mobile+this.mobile_device);
  }

  getScannedImplantsData() {
      this.masterService.getIndex('/scanned_implants/get', this.filter).subscribe(res => {
        // @ts-ignore
         this.scannedImplants = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page = res.data.per_page;
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;

      const newData = {};

      if (this.scannedImplants.length < 10) {
        for ( let i = this.scannedImplants.length; i < 9 ; i++) {
          this.scannedImplants.push(newData);
        }
      }
    });
  }

  setSearchPlaceHolder() {
    if (this.searchBy) { 
      switch (this.searchBy) {
        case 0:
          this.placeHolder = 'Search By Product Code';
          break;
          case 1:
          this.placeHolder = 'Search By PO No';
          break;
          case 2:
          this.placeHolder = 'Search By Invoice No';
          break;
         case 3:
          this.placeHolder = 'Search By Batch No.';
          break;
         case 4:
          this.placeHolder = 'Search by Expiry Date - yyyy-mm-dd';
          break;
         case 5:
          this.placeHolder = 'Search by Scanned Date - yyyy-mm-dd';
          break;
          default: this.placeHolder = 'Search By Product Code';
      }
    }
  }

  

  doSearch(): void {
  if (this.searchBy != null) {
    switch (this.searchBy) {
         case 0:
           Object.assign(this.filter, {wSearch: { type: 'str', field: 'products.code', text: this.searchTxt}});
           break;
           case 1:
          Object.assign(this.filter, {wSearch: { type: 'int', field: 'invoices.id', text: this.searchTxt}});
          break;
          case 2:
          Object.assign(this.filter, {wSearch: { type: 'int', field: 'purchase_orders.id', text: this.searchTxt}});
          break;
         case 3:
          Object.assign(this.filter, {wSearch: { type: 'str', field: 'invoice_products.batch_no', text: this.searchTxt}});
          break;
         case 4:
          Object.assign(this.filter, {wSearch: { type: 'date', field: 'invoice_products.expire_date', text: this.searchTxt}});
          break;
         case 5:
          Object.assign(this.filter, {wSearch: { type: 'date', field: 'scanned_implants.created_at', text: this.searchTxt}});
          break;
         default:
          Object.assign(this.filter, {wSearch: { type: 'str', field: 'products.code', text: this.searchTxt}});
      }
    }  
  this.getScannedImplantsData();
  }

  doRefresh(): void {
     this.searchTxt = null;
     this.filter = {
       token: localStorage.getItem('token')
     };
     this.getScannedImplantsData();
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getScannedImplantsData();
  }

  navMobileScan(){
    if(this.mobile_device == 'iOS'){
      iOS_data(localStorage.getItem('token'));
    }
    if(this.mobile_device == 'android'){
      andriod_data(localStorage.getItem('token'));
    }    
  }

}